import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PillModal from '../pillmodals/PillModal';
import AddAccent from '../../../../../common/Icons/Add-Accent.svg';
import defaultStyles from './AddFilterPill.module.scss';
import filterDefinitionsPropType from '../../../filterDefinitionsPropType';

class AddFilterPill extends React.Component {
    constructor(props) {
        super(props);
        this.addButtonRef = React.createRef();
        this.state = {
            pinModalRight: false
        };

        this.updateSizingDetails = this.updateSizingDetails.bind(this);
    }

    componentDidMount() {
        this.updateSizingDetails();
        window.addEventListener('resize', this.updateSizingDetails);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.updateSizingDetails();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSizingDetails);
    }

    updateSizingDetails() {
        if (this.addButtonRef.current) {
            this.setState({
                pinModalRight: window.innerWidth - this.addButtonRef.current.offsetLeft < 224
            });
        }
    }

    render() {
        return (
            <div className={ this.props.styles.pillWrapper } ref={ this.addButtonRef }>
                <div className={
                    classNames(this.props.styles.pill, this.props.styles.filterPillAdd)
                }
                >
                    <button
                        className={ this.props.styles.button }
                        type="button"
                        onClick={ () => this.props.openFilter(this.props.isOpen ? null : 'ADD_FILTER') }
                    >
                        <img className={ this.props.styles.img } src={ AddAccent } alt="" />Add Filter
                    </button>
                    { this.props.isOpen ? (
                        <PillModal
                            filter={ {
                                title: 'Filter By',
                                type: 'List',
                                value: this.props.filters.map((f) => f.title)
                            } }
                            currentFilters={ this.props.filters }
                            isAddFilter
                            closeFilter={ () => { this.props.openFilter(null); } }
                            updateFilter={ noop }
                            getAvailableListValues={ noop }
                            handleAdd={ this.props.handleAdd }
                            filterDefinition={ {
                                title: 'Filter By',
                                type: 'List',
                                value: this.props.filters.map((f) => f.title),
                                availableValues: this.props.filterDefinitions.map((af) => af.title)
                            } }
                            pushRight={ this.state.pinModalRight }
                        />
                    ) : null }
                </div>
            </div>
        );
    }
}

AddFilterPill.propTypes = {
    filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    filterDefinitions: filterDefinitionsPropType.isRequired,
    openFilter: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    handleAdd: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

AddFilterPill.defaultProps = {
    isOpen: false,
    styles: defaultStyles
};

export default AddFilterPill;
